var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrialUsers = function SvgTrialUsers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4144 8.0715C22.8692 8.0715 24.0485 6.92025 24.0485 5.50011C24.0485 4.07996 22.8692 2.92871 21.4144 2.92871C19.9596 2.92871 18.7803 4.07996 18.7803 5.50011C18.7803 6.92025 19.9596 8.0715 21.4144 8.0715Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4144 11.9287C18.5949 11.9287 15.4305 13.6017 15.1584 14.1787C14.9354 14.6516 14.8291 16.1072 14.8291 16.1072C14.8291 16.6387 15.2705 17.0715 15.815 17.0715H27.0138C27.5583 17.0715 27.9997 16.6387 27.9997 16.1072C27.9997 16.1072 27.8934 14.6516 27.6704 14.1787C27.3983 13.6017 24.2338 11.9287 21.4144 11.9287V11.9287Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2198 7.92299C12.1781 7.92299 13.7657 6.37322 13.7657 4.46149C13.7657 2.54976 12.1781 1 10.2198 1C8.26139 1 6.67383 2.54976 6.67383 4.46149C6.67383 6.37322 8.26139 7.92299 10.2198 7.92299Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2194 12.0769C6.27218 12.0769 1.84192 14.3289 1.46097 15.1057C1.14878 15.7423 1 17.7018 1 17.7018C1 18.4173 1.61795 18.9999 2.38024 18.9999H18.0586C18.8208 18.9999 19.4388 18.4173 19.4388 17.7018C19.4388 17.7018 19.29 15.7423 18.9778 15.1057C18.5969 14.3289 14.1666 12.0769 10.2194 12.0769Z",
    fill: "white",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrialUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trial-users.ef669efe.svg";
export { ForwardRef as ReactComponent };